import { Reducer } from "redux"
import { AuthorizationState, AuthorizationActionTypes } from "./types";

// 初始化state
const initialState: AuthorizationState = {
  isLogin: true,
  userInfo: {
    uid: 0,
    uidName: "",
    cid: 0,
    cidName: "",
    mobilePhone: "",
    email: "",
    resultDetaul: "",
    superAdmin: 0,
    appAdmin: 0,
    existCoop: -1
  },
  sysParam: {}
};

// 根据token获取用户信息
const getUserReducer: Reducer<AuthorizationState> = (state = initialState, action) => {
  switch (action.type) {

    case AuthorizationActionTypes.FETCH_USER_INFO_FINISH: {
      const {
        uid,
        cid,
        cidName,
        mobilePhone,
        email,
        resultDetaul,
        superAdmin, appAdmin, existCoop, uidName,  // 请不要换行，四个参数连着写是为了调试方便，
      } = action.payload.data;
      return {
        ...state,

        isLogin: action.payload.result === 0,
        userInfo: {
          uid,
          uidName,
          cid,
          cidName,
          mobilePhone,
          email,
          resultDetaul,
          superAdmin,
          appAdmin,
          existCoop,
        }
        
        // isLogin: true,
        // userInfo: {
        //   uid,
        //   uidName: "晁盖",
        //   cid,
        //   cidName,
        //   mobilePhone,
        //   email,
        //   resultDetaul,
        //   superAdmin: 1,
        //   appAdmin: 1,
        //   existCoop: 1
        // }

      };
    }

    case AuthorizationActionTypes.FETCH_USER_INFO_ERROR: {
      return {
        ...state,
        isLogin: false,
      };
    }

    case AuthorizationActionTypes.FETCH_SYS_PARAM_FINISH: {
      const sysParam = action.payload;
      return {
        ...state,
        sysParam
      }
    }

    default: {
      return { ...state };
    }
  }
}

export { getUserReducer };



// WEBPACK FOOTER //
// ./src/store/authorization/reducer.ts